import { ColumnType, DataColumn } from '../Store/Column';
import { Dataset } from '../Store/Dataset';
import { Schema } from '../Store/Schema';
export class DatasetBuilder {
    build(columns, data) {
        const schema = new Schema();
        for (const columnInfo of columns) {
            const columnName = columnInfo.name;
            let columnType = this.getColumnType(columnInfo.type);
            if (columnType == null) {
                columnType = ColumnType.STRING;
            }
            schema.addColumn(new DataColumn(columnName, columnType));
        }
        return new Dataset(schema, data);
    }
    getColumnType(typeName) {
        switch (typeName.toLocaleLowerCase()) {
            case 'boolean':
                return ColumnType.BOOLEAN;
            case 'date':
                return ColumnType.DATE;
            case 'datetime':
                return ColumnType.DATETIME;
            case 'float':
                return ColumnType.FLOAT;
            case 'integer':
                return ColumnType.INTEGER;
            case 'string':
                return ColumnType.STRING;
        }
    }
}
